module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/fs_title@3x.png?1.0.17";